export const SET_CLUES = 'SET_CLUES';
export const SET_CLUE = 'SET_CLUE';
export const ADD_CLUE = 'ADD_CLUE';
export const ADD_CLUES = 'ADD_CLUES';
export const UPDATE_CLUE = 'UPDATE_CLUE';
export const REMOVE_CLUE = 'REMOVE_CLUE';
export const CLEAR_CLUE = 'CLEAR_CLUE';
export const CLEAR_CLUES = 'CLEAR_CLUES';
